module.exports = __webpack_public_path__ + "static/media/catastrophic.f74e91bc.svg";